import Vue from 'vue'
import Vuex from 'vuex'
import * as actions from './actions'
import * as getters from './getters'

Vue.use(Vuex);

// 应用初始状态
const state = {
  count: 10,
  userInfo: {},
  loginFlay: false,
  authEnable: true, // 开启的话，前端会进行页面按钮和菜单权限控制;
  routes: [],
  roles: [],
  authViews: {},
  dictsOptions: []
};

// 定义所需的 mutations
const mutations = {
  INCREMENT(state) {
    state.count++;
  },
  updataVuexUserInfo(state, userInfo) {
    state.userInfo = userInfo;
  },
  showLoginFlay(state) {
    state.loginFlay = true;
  },
  hideLoginFlay(state) {
    state.loginFlay = false;
  },
  setRoutes(state, routes) {
    state.routes = routes;
  },
  updateRoutes(state, authorizedViewList) {
    if (!state.authEnable) {
      return;
    }
    let removeIndexList = [];
    state.routes.forEach(function (element, index) {
      // 有authId的需要校验后过滤
      let authorized;
      if (element.authId) {
        // 如果有authId,但拿不到授权信息，默认是没有权限的
        if (authorizedViewList) {
          authorized = authorizedViewList.includes(element.authId);
        } else {
          authorized = false;
        }
      } else {
        authorized = true;
      }
      // console.log(element.authId + ',' + authorized);
      // return authorized;
      if (!authorized) {
        removeIndexList.push(index);
      }
    });
    for (let i = 0; i < removeIndexList.length; i++) {
      // 打印数组中的情况，便于跟踪数组中数据的变化
      // 调整索引
      let index = removeIndexList[i] - i;
      // console.log('delete index=' + index);
      state.routes.splice(index, 1);
    }
  },
  setRoles(state, roles) {
    state.roles = roles;
  },
  setAuthViews(state, authorizedViewList) {
    // console.log(authorizedViewList);
    // 如果已经有值，刷新
    Object.keys(state.authViews).forEach(function (key) {
      state.authViews[key] = !!authorizedViewList.includes(key);
    });
    for (let key of authorizedViewList) {
      if (!Object.keys(state.authViews).includes(key)) {
        state.authViews[key] = true;
      }
    }
    // state.authViews = Object.assign({}, state.authViews)
    // console.log(state.authViews);
  },
  dictsOptions(state, map) {
    state.dictsOptions = map;
  }
};

// 创建 store 实例
export default new Vuex.Store({
  actions,
  getters,
  state,
  mutations
})



// WEBPACK FOOTER //
// ./src/vuex/store.js